export default __webpack_public_path__ + "static/media/icon-tubulacao-esgoto.0719df18.svg";